import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { FETCH_ALL_CASE_DATA, fetchAllCaseDataSuccess, fetchAllCaseDataFail } from '../actions/actions_fetchAllCases';
import util from '../../utils/Helpers';

import 'isomorphic-fetch';
import { polyfill } from 'es6-promise';
polyfill();

let apiIndex = util.isLocalhost() ? 'http://localhost:9393/auth' : `${util.getCurrentHost()}/auth/auth`;

const fetchAllCaseDataEpic = (action$) =>
	action$.pipe(
		ofType(FETCH_ALL_CASE_DATA),
		mergeMap((action) =>
			fetch(`${apiIndex}/visa/all?user_id=${action.payload}`, {
				credentials: 'include',
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Basic ' + window.btoa('flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1')
				}
			})
				.then((response) => response.json())
				.then((data) => fetchAllCaseDataSuccess(data))
				.catch((error) => fetchAllCaseDataFail(error))
		)
	);

export default fetchAllCaseDataEpic;

//documents
//https://test.flag.dol.gov/api/case_platform/file?document_id=131849
